<!-- <mat-progress-bar
  *ngIf="isSaving"
  color="accent"
  mode="indeterminate"
></mat-progress-bar> -->

<mat-card
  matRipple
  [matRippleDisabled]="!clickable"
  class="pt-0 bg-transparent"
  [class.border]="border"
  [class.clickable]="clickable"
  style="box-shadow: none"
>
  @if(spot()) {@if(!isEditing) {
  <mat-card-header class="pb-2 px-3">
    <mat-card-title class="d-flex align-items-center w-100 gap-1">
      <span
        class="flex-grow-1 w-100 overflow-hidden d-flex flex-row align-items-center gap-2"
      >
        @if(spot()?.isIconic) {
        <mat-icon
          style="width: 24px; flex-shrink: 0"
          matTooltip="Iconic Spot"
          i18n-matTootltip
          >stars</mat-icon
        >
        }
        <span [matTooltip]="spot()!.name()" class="text-truncate d-block">{{
          spot()!.name()
        }}</span>
      </span>

      <!-- dismiss button -->
      @if(dismissable) {
      <button
        mat-icon-button
        (click)="dismissed()"
        i18n-matTooltip
        matTooltip="Close Spot"
      >
        <mat-icon>close</mat-icon>
        <!-- <mat-icon>turn_right</mat-icon> -->
        <!-- <mat-icon>route</mat-icon> -->
        <!-- <mat-icon>share_location</mat-icon> -->
      </button>
      }
    </mat-card-title>
    <mat-card-subtitle class="d-flex flex-row justify-content-between">
      <div class="d-flex flex-column justify-content-center text-truncate">
        @if(spot()?.rating) {
        <app-spot-rating
          class="flex-shrink-0"
          [rating1to5]="spot()!.rating"
          [showNumReviews]="true"
          [numReviews]="spot()!.numReviews"
        ></app-spot-rating>
        } @if(spot()?.address()) {
        <span class="text-truncate">{{ spot()!.localityString() }}</span>
        }
      </div>

      <!-- Icon buttons in header -->
      @if(!isEditing) {
      <div class="spot-button-row">
        <!--@if(authenticationService.isSignedIn) {
        @if (!visited) {
         <button
          mat-icon-button
          color="accent"
          matTooltip="Bookmark this spot"
          aria-label="Icon button with a bookmark icon"
          (click)="bookmarked = !bookmarked; $event.stopPropagation()"
        >
          <mat-icon>{{ bookmarked ? "bookmark" : "bookmark_border" }}</mat-icon>
        </button>

        }
        <button
          mat-icon-button
          color="primary"
          matTooltip="Mark this spot as visited"
          aria-label="Icon button with a flag icon"
          (click)="
            visited = !visited; bookmarked = false; $event.stopPropagation()
          "
        >
          <mat-icon>{{ visited ? "flag" : "outlined_flag" }}</mat-icon>
        </button> 
        }
        -->

        @if(!isLocalSpot()) {
        <button
          mat-icon-button
          matTooltip="Share this spot"
          i18n-matTooltip="
            Share spot tooltip|The tootltip of the share spot icon
            button@@share_spot_tooltip"
          aria-label="Icon button with a share icon"
          i18n-aria-label="
            Share spot aria label|The aria label of the share spot icon
            button@@share_spot_aria_label"
          (click)="shareSpot(); $event.stopPropagation()"
        >
          <mat-icon>share</mat-icon>
        </button>
        }
        <button
          mat-icon-button
          matTooltip="Directions to spot"
          i18n-matTooltip="
            Directions spot tooltip|The tooltip of the directions spot icon
            button@@directions_spot_tooltip"
          aria-label="Icon button with a directions icon"
          i18n-aria-label="
            Spot directions aria label|The aria label of the directions spot
            icon button@@directions_spot_aria_label"
          (click)="openDirectionsInMaps()"
        >
          <mat-icon>directions</mat-icon>
          <!-- <mat-icon>turn_right</mat-icon> -->
          <!-- <mat-icon>route</mat-icon> -->
          <!-- <mat-icon>share_location</mat-icon> -->
        </button>
      </div>
      }
    </mat-card-subtitle>
    <!-- <mat-card-subtitle class="pt-2 d-flex flex-row">
      @if(spot.type && spot.type !== "other") {
      <mat-chip class="me-1">{{ capitalize(spot.type) }}</mat-chip>
      } @if(spot.area && spot.area !== "other") {
      <mat-chip [color]="spot.area === 'private' ? 'warn' : ''">{{
        capitalize(spot.area)
      }}</mat-chip>
      }
    </mat-card-subtitle> -->
  </mat-card-header>
  }
  <!-- if(!isEditing)  -->

  @if(report) {
  <div class="report-info">
    <span class="mat-h3 m-0" i18n
      >This spot was reported as "{{ report.reason }}"</span
    >
  </div>
  }
  <!-- @if(report) -->

  <mat-card-content>
    @if(!isEditing) {
    <!-- spot media carousel  -->
    @if(spot()?.media() && spot()!.media().length > 0) {
    <app-img-carousel class="mb-2 mt-1" [media]="spot()!.media()">
    </app-img-carousel>
    }

    <!-- Spot Description -->
    <!-- @if(spot.media() && spot.media().length > 0) {
    <swiper-container
      class="spot-media-swiper"
      [navigation]="true"
      [pagination]="{ clickable: true }"
    >
      @for(mediaObj of spot.media(); track mediaObj) {
      <swiper-slide
        ><img ngSrc="{{ mediaObj.src }}" class="spot-img" fill />
      </swiper-slide>
      }
    </swiper-container>
    } -->

    <!-- Google place -->
    @if(googlePlace()) {
    <h4 class="mat-title-small" i18n>This spot on Google Maps®</h4>
    <a
      [href]="googlePlace()!.url"
      target="_blank"
      rel="noopener noreferrer"
      style="text-decoration: none; color: inherit"
    >
      <mat-card
        matRipple
        class="mat-elevation-z0 clickable border rounded d-flex flex-row mb-4 overflow-hidden"
        style="height: 80px"
      >
        @if(googlePlace()!.photo_url) {
        <div mat-card-sm-image class="google-img-container">
          <img [ngSrc]="googlePlace()!.photo_url!" fill />
        </div>
        }
        <mat-card-header class="pb-2">
          <mat-card-title
            class="text-truncate mw-100 pt-2 mat-title-medium"
            style="font-size: 1.1rem"
          >
            {{ googlePlace()!.name }}
          </mat-card-title>
          <mat-card-subtitle i18n class="d-flex flex-row gap-2 mat-title-small">
            @if(googlePlace()!.rating) { Rating:
            <app-spot-rating
              [rating1to5]="googlePlace()!.rating!"
              [showEmptyStars]="false"
              [isCompact]="true"
            ></app-spot-rating>
            }

            <!-- <span class="text-truncate" style="flex-shrink: 1">
            {{ spotLocality }}
          </span> -->
          </mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>
    }

    <!-- Freatures -->
    @if(spot()?.amentitiesArray() && spot()!.amentitiesArray().length > 0) {
    <div class="mb-4">
      <h4
        i18n="amenities header|The header for the spot features and amenities"
        class="mat-title-small"
      >
        Features and amenities
      </h4>
      <mat-chip-set>
        @for(amenity of spot()!.amentitiesArray(); track amenity) {
        <mat-chip>
          <mat-icon matChipAvatar>{{ amenity.icon }}</mat-icon>
          {{ amenity.name }}
        </mat-chip>
        }
      </mat-chip-set>
    </div>
    }

    <!-- Spot Description -->
    @if(spot()?.description()) {
    <div>
      <h4
        class="mat-title-small"
        i18n="description header|The header for the spot description"
      >
        Description
      </h4>
      <p>
        {{ spot()!.description() }}
      </p>
    </div>
    }

    <!-- Ratings -->
    @if(!isLocalSpot() && (spot()?.rating || authenticationService.isSignedIn))
    {
    <div class="mb-4">
      <h4 class="mat-title-small" i18n>Rating and user reviews</h4>
      @if(spot()!.rating) {
      <div class="d-flex flex-row align-items-center mb-3">
        <div
          class="d-flex flex-column align-items-center justify-content-center gap-1 pe-4"
        >
          <span class="mat-headline-large mb-0">{{
            spot()!.rating!.toFixed(1)
          }}</span>
          <app-spot-rating
            [rating1to5]="spot()!.rating"
            [showNumReviews]="false"
            [showRating]="false"
          ></app-spot-rating>
          @if(spot()?.numReviews) {
          <span class="mat-body-medium text-nowrap" i18n
            >{spot()!.numReviews, plural, =0 {no reviews} =1 {1 review} other
            {{{ spot()!.numReviews }} reviews}}</span
          >
          }
        </div>
        @if(spot()?.normalizedRatingHistogram()) {
        <div class="flex-grow-1 hist-grid-container">
          @for(item of spot()!.normalizedRatingHistogram() | keyvalue | reverse;
          track item) {
          <!-- row -->
          <div class="grid-item mat-label-medium">
            {{ item.key }}
          </div>
          <mat-progress-bar
            class="grid-item rounded"
            mode="determinate"
            [value]="100 * item.value"
            style="margin-top: -2px"
          ></mat-progress-bar>
          <div class="grid-item mat-label-medium">
            ({{ spot()!.ratingHistogram()[item.key | asRatingKey] }})
          </div>
          }
        </div>
        }
      </div>
      } @else {
      <p i18n>This spot has no reviews yet, be the first to leave one!</p>
      }
      <!-- if(spot.rating) -->

      <!-- Spot review histogram -->
      <!-- // TODO review histogram -->

      @if(authenticationService.isSignedIn) {
      <!-- // TODO in the future also make sure the user visited the spot -->
      <button
        mat-stroked-button
        color="primary"
        i18n-matTooltip="
          Review this spot button tooltip|Tooltip of button to review the
          spot@@review_spot_tooltip"
        matTooltip="Review this spot"
        (click)="openSpotReviewDialog()"
        i18n="
          Review spot button label|Button to review the spot
          label@@review_spot_button_label"
      >
        Review spot
      </button>
      }
    </div>
    }

    <!-- Spot Address or Location and action buttons -->
    <div class="d-flex justify-start mb-4 flex-column">
      @if(spot()?.address()?.formatted) {
      <h4
        class="mat-title-small"
        i18n="
          Address subtitle|The address subtitle in the spot
          details@@address_title"
      >
        Address
      </h4>
      <p class="mat-body-large">{{ spot()!.address()?.formatted }}</p>
      } @else {
      <h4 class="mat-title-small" i18n>Location</h4>
      <p class="mat-body-large">
        {{ spot()!.locationString() }}
      </p>
      }
      <div class="d-flex flex-column flex-xl-row gap-2">
        <button
          mat-stroked-button
          color="primary"
          class="flex-grow-1 flex-basis-0 py-2"
          i18n-matTooltip="
            Open in maps button tooltip|Tooltip of button to open the spot in
            maps@@open_maps_tooltip"
          matTooltip="Open the location of this spot in Maps"
          (click)="openSpotInMaps()"
          i18n="
            Open in maps button|Button to open the spot in
            maps@@open_maps_button_label"
        >
          Open in {{ isAppleMaps ? "Apple Maps" : "Google Maps" }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          class="flex-grow-1 flex-basis-0 py-2"
          matTooltip="Navigate to this spot"
          (click)="openDirectionsInMaps()"
          i18n="@@directions_spot_tooltip"
        >
          Navigate to spot
        </button>
      </div>
    </div>

    <!-- Spot Challenges -->
    <!-- <mat-divider></mat-divider> -->
    <!-- <div class="mb-4">
      <h4 class="mat-title-small mt-3" i18n>Challenges</h4>
      <div class="challenge-preview-grid">
        @for(challenge of [].constructor(3); track challenge) {
        <div class="d-flex flex-column">
          <div
            class="rounded w-100 overflow-hidden position-relative"
            style="aspect-ratio: 1; background-color: #2c2d31"
          >
            <img
              ngSrc="/assets/no_media.png"
              fill
              class="w-100 h-100"
              style="object-fit: cover"
            />
          </div>
          <span>Challenge</span>
        </div>
        }
      </div>
    </div> -->

    <!-- Action buttons -->
    @if(authenticationService.isSignedIn && editable) {
    <mat-divider></mat-divider>
    <div class="d-flex my-3 gap-2">
      <button
        mat-stroked-button
        i18n-matTooltip
        matTooltip="Edit this spot"
        i18n-aria-label
        (click)="editButtonClick()"
        class="flex-grow-1 flex-basis-0"
        i18n="Edit button label|Label of the button to edit the spot"
      >
        Edit
      </button>
      <button
        mat-stroked-button
        color="warn"
        i18n-matTooltip
        matTooltip="Report this spot"
        i18n-aria-label
        aria-label="Example icon button with a share icon"
        class="flex-grow-1 flex-basis-0"
        (click)="openSpotReportDialog()"
        i18n="report button label|Label of the button to report the spot"
      >
        Report
      </button>
    </div>
    }
    <!-- @if(authenticationService.isSignedIn && editable) -->

    } @else {
    <!-- Spot title editing field -->
    <form>
      <mat-form-field style="width: 100%">
        <mat-label
          i18n="
            spot name placeholder|Placeholder of the spot name in the edit form
          "
          >Spot name</mat-label
        >
        <input
          #spotNameInput
          matInput
          [value]="spot()!.name()"
          (change)="
            spot()!.setName(getValueFromEventTarget($event.target), locale)
          "
        />
      </mat-form-field>
    </form>

    <!-- Media preview grid -->
    <app-media-preview-grid
      [media]="spot()!.userMedia()"
      (mediaChanged)="mediaChanged($event)"
    ></app-media-preview-grid>

    <!-- Image upload  -->
    <div class="pb-4 pt-2">
      <app-media-upload
        class="w-100"
        [allowedMimeTypes]="['image/jpg', 'image/jpeg', 'image/png']"
        [multipleAllowed]="true"
        [storageFolder]="mediaStorageFolder"
        (newMedia)="setNewMediaFromUpload($event)"
      >
      </app-media-upload>
    </div>

    <!-- <mat-form-field style="width: 100%">
      <mat-label i18n>Spot type</mat-label>
      <mat-select
        [value]="spot?.type"
        (selectionChange)="spot.type = $event.value"
      >
        <mat-option *ngFor="let type of spotTypes" [value]="type">
          {{ capitalize(type) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label i18n>Spot area</mat-label>
      <mat-select
        [value]="spot?.area"
        (selectionChange)="spot.area = $event.value"
      >
        <mat-option *ngFor="let area of spotAreas" [value]="area">
          {{ capitalize(area) }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->

    <!-- Iconic -->
    <mat-slide-toggle
      i18n
      class="mb-4"
      [checked]="spot()!.isIconic"
      color="primary"
      (change)="setSpotIconicFromToggle($event)"
      >Iconic Spot</mat-slide-toggle
    >

    <!-- Features and Amenities -->
    <div class="w-100 mb-4">
      <h4
        i18n="amenities header|The header for the spot features and amenities"
        class="mat-title-small"
      >
        Features and amenities
      </h4>

      <mat-chip-listbox>
        <mat-chip-option
          [selected]="spot()!.amenities().indoor"
          (selectionChange)="
            spot()!.amenities().indoor = $event.selected;
            spot()!.amenities().outdoor = !$event.selected
          "
          ><mat-icon matChipAvatar>{{ AmenityIcons["indoor"] }}</mat-icon
          >{{ AmenityNames["indoor"] }}</mat-chip-option
        >
        <mat-chip-option
          [selected]="spot()!.amenities().outdoor"
          (selectionChange)="
            spot()!.amenities().outdoor = $event.selected;
            spot()!.amenities().indoor = !$event.selected
          "
          ><mat-icon matChipAvatar>{{ AmenityIcons["outdoor"] }}</mat-icon
          >{{ AmenityNames["outdoor"] }}</mat-chip-option
        >
      </mat-chip-listbox>
      @if(spot()!.amenities().indoor) {
      <mat-chip-set>
        @for(amenity of IndoorAmenities; track amenity) {
        <mat-chip-option
          [selected]="spot()!.amenities()[amenity]"
          (selectionChange)="spot()!.amenities()[amenity] = $event.selected"
          ><mat-icon matChipAvatar>{{ AmenityIcons[amenity] }}</mat-icon
          >{{ AmenityNames[amenity] }}</mat-chip-option
        >
        }
      </mat-chip-set>
      } @if(spot()!.amenities().outdoor) {
      <mat-chip-set>
        @for(amenity of OutdoorAmenities; track amenity) {
        <mat-chip-option
          [selected]="spot()!.amenities()[amenity]"
          (selectionChange)="spot()!.amenities()[amenity] = $event.selected"
          ><mat-icon matChipAvatar>{{ AmenityIcons[amenity] }}</mat-icon
          >{{ AmenityNames[amenity] }}</mat-chip-option
        >
        }
      </mat-chip-set>
      }
      <mat-chip-set>
        @for(amenity of GeneralAmenities; track amenity) {
        <mat-chip-option
          [selected]="spot()!.amenities()[amenity]"
          (selectionChange)="spot()!.amenities()[amenity] = $event.selected"
          ><mat-icon matChipAvatar>{{ AmenityIcons[amenity] }}</mat-icon
          >{{ AmenityNames[amenity] }}</mat-chip-option
        >
        }
      </mat-chip-set>
    </div>

    <!-- Description -->
    <h4
      class="mat-title-small"
      i18n="description header|The header for the spot description"
    >
      Description
    </h4>
    <mat-form-field style="width: 100%">
      <mat-label i18n>Description</mat-label>
      <textarea
        matInput
        i18n-placeholder="
          Spot description edit field placeholder|Placeholder of the spot
          description edit field
        "
        placeholder="Description of the spot, its features and more..."
        [value]="spot()!.description()"
        (change)="descriptionTextChanged(spot()!, $event.target)"
      ></textarea>
    </mat-form-field>

    <div class="my-3 d-flex justify-start">
      @if(!isNewSpot && !hasBounds()) {
      <button
        mat-stroked-button
        (click)="addBoundsClicked()"
        i18n="
          Add bounds button label|Label of the button to add bounds to a spot
        "
      >
        Add bounds
      </button>
      }
    </div>
    }
  </mat-card-content>
  @if(isEditing) {
  <mat-card-actions class="mt-3 gap-2">
    @if(editable) {
    <button
      mat-stroked-button
      color="warn"
      (click)="discardButtonClick()"
      class="flex-grow-1 flex-basis-0"
      i18n="Discard changes button label|Label of the button to discard changes"
    >
      Discard changes
    </button>
    <button
      mat-stroked-button
      color="primary"
      (click)="saveButtonClick()"
      class="flex-grow-1 flex-basis-0"
      i18n="Save changes button label|Label of the button to save changes"
    >
      Save changes
    </button>
    }
  </mat-card-actions>
  } }
</mat-card>
